import UniversalMaps from 'components/UniversalMaps';
import { useParams, useNavigate } from 'react-router-dom';

export default function Maps() {
	const { code } = useParams();
	const navigate = useNavigate();

	const fallbackCallback = () => navigate('/');

	return <UniversalMaps mode="standard" code={code} cb={fallbackCallback} />;
}
